import { AIActionType, ChatLogEntry } from "./types";
import deepmerge from "deepmerge";
import { combineReducers } from "redux";
import {
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";

function updateState(
  state: ChatLogEntry[],
  supernovaId: string,
  toMerge: Partial<ChatLogEntry>
) {
  // Reverse search for performance since we'll be updating items at the end
  // of the array
  const existingIndex = state["findLastIndex"](
    (el) => el.supernovaId === supernovaId
  );
  const clonedState = [...state];
  clonedState[existingIndex] = deepmerge(state[existingIndex], toMerge);
  return clonedState;
}

function handleChatInteraction(state: ChatLogEntry[], action): ChatLogEntry[] {
  switch (action.type) {
    case getStartActionName(TopLevelMethod.AI_CHAT):
      return [
        ...state,
        { question: action.apiCallArgs[0].question, supernovaId: action.uuid },
      ];
    case getSuccessActionName(TopLevelMethod.AI_CHAT):
      return updateState(state, action.uuid, { answer: action.resultData });
    case getFailActionName(TopLevelMethod.AI_CHAT):
      return updateState(state, action.uuid, { hasError: true });
    default:
      return state;
  }
}

function chatLog(state: ChatLogEntry[] = [], action) {
  // Intentional variable shadow
  state = handleChatInteraction(state, action);
  switch (action.type) {
    case getSuccessActionName(TopLevelMethod.AI_EVENT):
      if (action.resultData.type === "score") {
        const existingIndex = state["findLastIndex"](
          (el) => el.answer?.messageId === action.apiCallArgs[0].messageId
        )!;
        return updateState(state, state[existingIndex].supernovaId, {
          score: action.resultData,
        });
      }
      return state;
    case AIActionType.NEW_CHAT:
      return [];
    default:
      return state;
  }
}

const lastChatInteraction = (
  state: ChatLogEntry | null = null,
  action
): ChatLogEntry | null => {
  const stateToUse = state ? [state] : [];
  return handleChatInteraction(stateToUse, action)[0] ?? null;
};

const reducer = combineReducers({ chatLog, lastChatInteraction });
export default reducer;
